import React, { Component } from "react";
import  "./EmptyState.scss";
import { FormattedMessage, injectIntl } from 'react-intl';



class EmptyState extends Component {

  render() {
    return (
      <div className = "emptyState">
        { this.props.searchMode ? 
            <div>
                <div className="title">{this.props.intl.formatMessage({id: 'widget.noResult'})}</div>
                <div className="info">
                    <p>{this.props.intl.formatMessage({id: 'widget.lookedEverywhere'})} {this.props.folder.title} </p>
                    <p>{this.props.intl.formatMessage({id: 'widget.moreOptions'})}</p>
                </div>
                <div className="goBack" onClick = {() => this.props.openFolder(this.props.folder) }>{this.props.intl.formatMessage({id: 'widget.back'})}</div>
            </div> :
            <div className="message">
                <div> {this.props.intl.formatMessage({id: 'widget.noFiles'})}</div>
                <div> {this.props.intl.formatMessage({id: 'widget.CheckBackLater'})}</div>
            </div>
        }
      </div>
    );
  }
}
export default injectIntl(EmptyState);




// WEBPACK FOOTER //
// ./src/widget/components/emptyState/EmptyState.js